__turbopack_context__.v({
  "body": "CDCm_a_body",
  "brMobile": "CDCm_a_brMobile",
  "brTablet": "CDCm_a_brTablet",
  "copy": "CDCm_a_copy",
  "filterDefs": "CDCm_a_filterDefs",
  "lines": "CDCm_a_lines",
  "orbLarge": "CDCm_a_orbLarge",
  "orbSmall": "CDCm_a_orbSmall",
  "ring": "CDCm_a_ring",
  "section": "CDCm_a_section",
  "spMobile": "CDCm_a_spMobile",
  "spTablet": "CDCm_a_spTablet",
  "title": "CDCm_a_title",
  "titleBlock": "CDCm_a_titleBlock",
  "titleLine": "CDCm_a_titleLine",
});
